import { Link } from 'react-router-dom';
import { latestAnime } from '@/mocks/home';

export default function LatestAnimeSection() {
  const renderStars = (rating: number) => {
    const full = Math.floor(rating);
    const hasHalf = rating - full >= 0.5;
    const stars = [];
    for (let i = 0; i < full; i++) {
      stars.push(<i key={`full-${i}`} className="ri-star-fill text-secondary-500 text-sm"></i>);
    }
    if (hasHalf) {
      stars.push(<i key="half" className="ri-star-half-line text-secondary-500 text-sm"></i>);
    }
    const remaining = 5 - full - (hasHalf ? 1 : 0);
    for (let i = 0; i < remaining; i++) {
      stars.push(<i key={`empty-${i}`} className="ri-star-line text-foreground-300 text-sm"></i>);
    }
    return stars;
  };

  return (
    <section className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="text-center mb-10">
        <div className="flex items-center justify-center gap-2 mb-3">
          <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          <span className="text-xs font-medium text-primary-600">最新上架</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-heading text-foreground-950">
          最新番剧推荐
        </h2>
        <p className="text-sm text-foreground-500 mt-3">
          每周精选最新上线的优质国漫，精彩不容错过
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {latestAnime.map((anime) => (
          <Link
            key={anime.id}
            to="/category/all"
            className="group rounded-lg bg-background-100 p-4 md:p-5 hover:bg-background-100/70 transition-colors"
          >
            <div className="flex items-center gap-1 mb-2">
              {renderStars(anime.rating)}
              <span className="text-xs text-foreground-500 ml-1">{anime.rating}</span>
            </div>
            <div className="flex items-center gap-1.5 mb-3">
              <h3 className="text-base font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                {anime.title}
              </h3>
              <span className="text-xs text-foreground-400">({anime.alias})</span>
            </div>
            <p className="text-sm text-foreground-600 line-clamp-3 leading-relaxed mb-4">
              {anime.description}
            </p>
            <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
              <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-xs font-medium text-accent-700">{anime.studio.slice(0, 1)}</span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">{anime.studio}</p>
                <p className="text-xs text-foreground-500">原作: {anime.author}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}